import roomPackages from '@constants/roomPackages';
import { LIVING_ROOM } from '@constants/roomTypes';

export default function getAtHomeCheckoutLink(count: number = 1): string {
  return (
    `/rooms/select-package/payment?roomPackageId=${roomPackages.AT_HOME}&roomTypeId=${LIVING_ROOM}&quantity=${count}`
  );
}
